import * as go from 'gojs'

function bindingFromHighlight (attribute, normalBackground, altBackground, selectedBackground, negativeBackground) {
  return new go.Binding(attribute, '',
    function (x) {
      if (x.isHighlighted) {
        return 'rgba(255,0,0,0.2)'
      } else if (!x.data.isInPalette && x.isSelected && selectedBackground) {
        return selectedBackground
      } else if (x.data.isNegative) {
        return negativeBackground
      } else if (x.data.backgroundAlt) {
        return altBackground
      } else {
        return normalBackground
      }
    }
  ).ofObject()
}

function bindingFromGroup (attribute, normalColour, altColour, selectedBackground, negativeBackground) {
  return new go.Binding(attribute, '', i => {
    if (i.isSelected) {
      return selectedBackground
    } else if (i.data.isNegative) {
      return negativeBackground
    } else if (i.data.backgroundAlt) {
      return altColour
    } else {
      return normalColour
    }
  }).ofObject()
}

function positionBinding () {
  return new go.Binding('position', 'position').makeTwoWay()
}

function bindingPositiveNegative (attribute, positiveColour, negativeColour) {
  return new go.Binding(attribute, '',
    function (x) {
      return x.data.isNegative ? negativeColour : positiveColour
    }
  ).ofObject()
}

export { bindingFromHighlight, bindingFromGroup, positionBinding, bindingPositiveNegative }



// WEBPACK FOOTER //
// ./src/graph_parts/binding.js